import { createPushNotification } from "src/modules/push-notification-protobuf";

export function createLowBatteryNotification({ monitoringId }) {
  return createPushNotification({
    iosPayload: {
      monitoringId,
      aps: {
        category: "lowBattery",
        alert: {
          "title-loc-key": "parentStation.veryLowBattery.title",
          "loc-key": "parentStation.veryLowBattery.message"
        },
        sound: "default",
        "mutable-content": 1
      }
    },
    androidPayload: {
      monitoringId,
      type: "lowBattery"
    }
  });
}

export function createMonitoringStoppedNotification({ monitoringId }) {
  return createPushNotification({
    iosPayload: {
      monitoringId,
      aps: {
        category: "monitoringStopped",
        alert: {
          "loc-key": "parentStation.monitoringStopped.message"
        },
        sound: "default",
        "content-available": 1
      }
    },
    androidPayload: {
      monitoringId,
      type: "monitoringStopped"
    }
  });
}
